import * as Session from 'state/session/helpers';
import { getStore } from 'app/hermes-redux';
import { getUser } from 'stores/user-store';

import { openWalkThrough } from 'walk-through/walk-through';
import { getCompanySettings } from 'stores/company-store';
import { goTo, getCurrentState } from 'router/navigation';

import { shouldShowConsentsToUserOnSignIn } from '../../pages/consent/helpers';
import { consentService } from '../../pages/consent/consent-service';
import {
  setRedirectionModel,
  shouldResumePostLoginFlow,
} from '../consent/actions';
import { get as storageGet, remove as storageRemove } from 'globals/storage';

// Handle the post login flow
// Check for consents and show walkthrough if needed
export const startPostLoginFlow = async () => {
  const msTeamsUrl = Session.getMsTeamsUrl() || '';
  const userObj = getUser();
  const dispatch = getStore().dispatch;
  const currentState = getCurrentState();

  await consentService.loadConsentsData();

  const { consent } = getStore().getState();

  if (msTeamsUrl) {
    return goTo('/return-to-teams');
  }

  if (storageGet('isCreatingLimitedAccount')) {
    dispatch(shouldResumePostLoginFlow(false));

    dispatch(
      setRedirectionModel({
        type: 'POP_UP',
        onCompleteGoTo: {
          name: 'limitedAccountConfirmation',
          params: {},
        },
      }),
    );

    storageRemove('isCreatingLimitedAccount');

    return;
  }

  // Note: Consent checking is now handled by performConsentRedirectionFlow in auth-handler
  // which runs during route authentication checks.
  //
  // IMPORTANT: Do NOT set shouldResumePostLoginFlow(true) here!
  //
  // The shouldResumePostLoginFlow flag should ONLY be set to true in these specific cases:
  // 1. SSO Signup Flow (unified-login.helpers.tsx:253)
  //    - User has signup_state === SSO_SIGNUP_PROVISIONED
  //    - Prevents consents from showing until signup form is completed
  // 2. Pending Consent Flow (unified-login.helpers.tsx:258)
  //    - User has signup_state === PENDING_CONSENT
  //    - Ensures post-login flow resumes after consents are accepted
  //
  // Previously, setting shouldResumePostLoginFlow(true) here caused a race condition between:
  // - auth-handler (route authentication): checking if consents should show via performConsentRedirectionFlow
  // - post-login flow: also checking consents and setting shouldResumePostLoginFlow(true)
  //
  // The conflict: post-login flow would defer consents (shouldDeferConsents=true), which then
  // caused auth-handler's consent check to fail, preventing consents from ever appearing to the user.
  //
  // If consents are being shown, this function will be called again after they're completed
  // (see sign-up-consents-container.tsx line 111-113)
  if (shouldShowConsentsToUserOnSignIn(consent.consents, currentState)) {
    return;
  }
  dispatch(shouldResumePostLoginFlow(false));

  dispatch(await getCompanySettings());

  openWalkThrough(userObj['user_id']);
};
